export const GENERAL_USER = 'general';
export const RBM = 'rbm';
export const SUPER_USER = 'super';

export const ROLE_TEXT = {
  [GENERAL_USER]: 'General User',
  [RBM]: 'ORM',
  [SUPER_USER]: 'Managing User',
};
